import { Link } from 'react-router';

import { Button, Circle, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react';

import { MagnifyingGlass } from '@enterprise/ui';

const NotFound = () => {
  return (
    <Flex
      alignItems="center"
      bg="hsp.50"
      justifyContent="center"
      minH="100vh"
      px={6}>
      <VStack
        bg="white"
        border="1px solid"
        borderColor="hsp.100"
        borderRadius="xl"
        maxW="420px"
        p={10}
        spacing={4}
        textAlign="center"
        w="full">
        <Circle
          bg="hsp.50"
          size="72px">
          <MagnifyingGlass
            color="var(--chakra-colors-hsp-500)"
            size="3x"
          />
        </Circle>

        <Heading
          fontSize="xl"
          fontWeight="medium">
          Page not found
        </Heading>

        <Text
          color="gray.500"
          fontSize="sm"
          lineHeight="tall">
          The page you're looking for doesn't exist or may have been moved.
        </Text>

        <HStack pt={2}>
          <Button
            as={Link}
            colorScheme="hsp"
            size="sm"
            to="/datastream/packagemanager">
            Take me home
          </Button>
        </HStack>
      </VStack>
    </Flex>
  );
};

export default NotFound;
